import { withLogoBackground } from "metabase/hoc/Background";
import Auth from "../../components/Auth";

export default withLogoBackground(Auth);
